<template>
  <div>
    <van-form class="post" @submit="isRepeat">
      <van-field v-if="type != 1" readonly clickable size="large" :rules="[{ required: true }]" name="picker"
        v-model="name" label="一尘版块" placeholder="点击选择一尘版块" @click="showPicker = true" />
      <van-popup v-model="showPicker" position="bottom">
        <van-picker show-toolbar :columns="plateList" value-key="name" @confirm="onConfirm"
          @cancel="showPicker = false" />
      </van-popup>
      <van-field v-if="type != 1" v-model="topic" size="large" name="标题" label="标题（最多不超过200个汉字）" placeholder="请输入帖子标题"
        :rules="[{ required: true }]">
        <template v-if="gradeShow" #button>
          <van-button native-type="button" size="small" icon="arrow-down" icon-position="right"
            @click="showAlert = true" plain>{{ gradeTitle }}</van-button>
        </template>
      </van-field>

      <div v-if="false" class="facerow">
        <div class="labelt">当前心情</div>
        <div @click="showFace = true" class="faceimg">
          <img :src="require('/src/assets/face/face' + faceValue + '.gif')" alt="" />
          <van-icon name="arrow" />
        </div>

        <van-popup v-model="showFace" position="center">
          <div style="padding: 10px;text-align: center;">
            <img class="emoimg" @click="checkedFace(index + 1)" v-for="(i, index) in 10" :key="index"
              :src="require('/src/assets/face/face' + (index + 1) + '.gif')" alt="" />
          </div>
        </van-popup>
      </div>
      <van-field v-model="body" size="large" autosize rows="5" type="textarea" show-word-limit maxlength="300"
        name="帖子内容" label="帖子内容" placeholder="请输入帖子内容描述" :rules="[{ required: true }]" />
      <uploader v-model="uploader"></uploader>

      <div class="footerbtn">
        <van-button style="border:none" :disabled="isloading" native-type="submit" block size="large">发表</van-button>
        <div class="line"></div>
        <van-button style="border:none" block size="large" @click="goback">我的帖子</van-button>
      </div>
    </van-form>

    <van-picker v-if="showAlert" show-toolbar title="标题醒目" @confirm="onConfirmShowAlert" :columns="columns"
      @cancel="showAlert = false" :default-index="gradeIndex" />
  </div>
</template>
<script>
import { client, options } from '@/utils/oss';
import { getSectionList, createPost, replyPost } from '@/api/base';
import { geturlparam, setRecordPostData, isWithinTwoMinutes } from '@/utils/index';
import { asyncIsVip } from '@/utils/isVip';
import uploader from '../components/uploader.vue';
export default {
  components: {
    uploader,
  },
  data() {
    return {
      showAlert: false,
      name: null,
      isloading: false,
      topic: '',
      body: '',
      uploader: [],
      isUploading: false,
      showPicker: false,
      plateList: [],
      sectionUrl: '',
      faceValue: 1,
      showFace: false,
      type: null, //1 回复
      url: null,
      isVip: false,
      sectionCode: null,
      testText: null,
      gradeTitle: '标题醒目',
      grade: 0,
      gradeShow: false,
      gradeIndex: 0,
      columns: [
        { text: '标题醒目', grade: 0, index: 0 },
        { text: '红色醒目', grade: 2, index: 1 },
        { text: '蓝色醒目', grade: 3, index: 2 },
        { text: '绿色醒目', grade: 4, index: 3 },
      ],
      columnsType: {
        0: null,
        2: 'red',
        3: 'blue',
        4: 'green',
      },
    };
  },
  created() {
    this.verification();
    this.init();
    this.type = this.$route.query.type ? this.$route.query.type : null;
    this.url = this.$route.query.url ? this.$route.query.url : null;
  },
  methods: {
    onConfirmShowAlert(e) {
      this.gradeTitle = e.text;
      this.grade = e.grade;
      this.gradeIndex = e.index;
      this.showAlert = false;
    },
    async verification() {
      let userinfo = JSON.parse(window.localStorage.getItem('ycUserinfos'));
      if (userinfo == null) {
        console.log('为空');
        this.$router.replace('/yclogin');
        return;
      }
      let arr = ['网信通', '董事长', '总经理', '版主', '管理员'];
      arr.map(item => {
        if (userinfo.grade.indexOf(item) != -1) {
          this.gradeShow = true;
        }
      });
    },
    isRepeat() {
      let that = this;
      //2分钟内是否发布过同样的帖子
      if (!this.topic) {
        return;
      }
      let obj = isWithinTwoMinutes(this.topic);
      if (obj != null) {
        let sectionName = null;
        this.plateList.map(item => {
          item.children.map(it => {
            if (it.code == obj.section) {
              sectionName = `${item.name}->${it.name}`;
            }
          });
        });
        let alretStr = `您${obj.lastUpdateTime}在${sectionName}版块，发布过相同主题的帖子，是否继续发布当前帖子？`;
        this.$dialog
          .confirm({
            title: '提示',
            message: alretStr,
            confirmButtonText: '继续发布',
            cancelButtonText: '修改',
          })
          .then(() => {
            that.onSubmit();
          })
          .catch(() => {
            // on cancel
            // that.isloading = false;
          });
      } else {
        that.onSubmit();
      }
    },

    async onSubmit(values) {
      let that = this;
      this.isVip = await asyncIsVip(2);
      if (!this.isVip) {
        return;
      }
      let userinfo = JSON.parse(window.localStorage.getItem('ycUserinfos'));
      if (userinfo.grade.indexOf('纯买家会员') != -1) {
        this.$dialog
          .alert({
            message: '纯买家会员没有发帖权限',
          })
          .then(() => {
            // on close
          });
        return;
      }
      this.$dialog
        .confirm({
          title: '提示',
          message: `当前账号：${userinfo.userName}\n 您确认发表贴子？`,
        })
        .then(() => {
          this.isloading = true;
          // on confirm
          this.$toast.loading({
            message: '正在努力为您发布帖子，请耐心等待...',
            forbidClick: true,
            duration: 0,
          });
          let imgs = [];
          that.uploader.map(item => {
            imgs.push('[IMG]' + item.url + '[/IMG]');
          });
          let body = `${that.body.replace(/\n/g, '<br/>')}<br/>${imgs.toString()}`;
          let obj = {
            body: body,
            sectionUrl: that.sectionUrl,
            topic: that.topic,
            userName: userinfo.userName,
            passWord: userinfo.passWord,
            topicXimoo: that.grade,
            uuid: userinfo.uuid,
            expression: `face${that.faceValue}.gif`,
            sectionCode: that.sectionCode,
          };
          createPost(obj)
            .then(res => {
              // res.data.color = this.columnsType[res.data.topicXimoo];
              setRecordPostData(res.data);
              that.$toast.loading({
                message: '发布成功，3秒后自动返回您发布的帖子...',
                forbidClick: true,
                duration: 0,
              });
              setTimeout(function () {
                that.$toast.clear();
                // that.$toast('发布成功');
                // that.$router.push('/createPost/list');
                let postobj = res.data;
                that.$router.push({
                  path: '/postView',
                  query: {
                    href: encodeURIComponent(encodeURIComponent(postobj.url)),
                    section: postobj.section,
                    title: postobj.title,
                    type: postobj.type,
                    author: postobj.author,
                    date: postobj.lastUpdateTime,
                  },
                });
                that.isloading = false;
              }, 3000);
            })
            .catch(error => {
              if (error.code == 1007) {
                that.$dialog
                  .alert({
                    message: '一尘网服务器异常，请稍后查看！',
                  })
                  .then(() => {
                    // on close
                    that.$router.push('/createPost/list');
                  });
              }
              if (error.code == 1008) {
                // 请检查一尘网会员发帖权限！
                that.$dialog
                  .alert({
                    message: '发帖失败,请检查一尘网会员发帖权限！',
                  })
                  .then(() => {
                    // on close
                  });
              }
              that.isloading = true;
            });
        })
        .catch(() => {
          // on cancel
          // that.isloading = false;
        });
    },
    goback() {
      this.$router.push('/createPost/list');
    },
    onConfirm(value, e) {
      //   this.ruleFrom.code = this.plateList[e[0]].children[e[1]].code;
      this.name = value.toString();
      let url = this.plateList[e[0]].children[e[1]].url;
      this.sectionUrl = geturlparam(url, 'boardid');
      this.sectionCode = this.plateList[e[0]].children[e[1]].code;
      this.showPicker = false;
    },
    init() {
      let str = window.localStorage.getItem('plateList');
      if (JSON.parse(str) && JSON.parse(str).length > 1) {
        this.plateList = JSON.parse(str);
      } else {
        getSectionList().then(res => {
          this.plateList = res.data.sort((a, b) => a.sortno - b.sortno);
          this.plateList.map(item => {
            item.children.sort((a, b) => a.sortno - b.sortno);
          });
          window.localStorage.setItem('plateList', JSON.stringify(this.plateList));
        });
      }
    },
    checkedFace(i) {
      this.faceValue = i;
      this.showFace = false;
    },
  },
};
</script>
<style>
.post .van-cell {
  display: block;
}

.post .van-cell .van-cell__title {
  width: auto;
}
</style>
<style scoped>
.facerow {
  display: flex;
  background: #fff;
  box-sizing: border-box;
  width: 100%;
  padding: 10px 16px;
  overflow: hidden;
  color: #323233;
  font-size: 16px;
  line-height: 24px;
  background-color: #fff;
  position: relative;
}

.facerow .labelt {
  color: #646566;
}

.facerow .faceimg {
  padding-left: 40px;
}

.facerow::after {
  position: absolute;
  box-sizing: border-box;
  content: ' ';
  pointer-events: none;
  right: 16px;
  bottom: 0;
  left: 16px;
  border-bottom: 1px solid #ebedf0;
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5);
}

.emoimg {
  width: 33px;
  height: 32px;
  margin-right: 20px;
  margin-bottom: 20px;
}

.emoimg:nth-child(3n) {
  margin-right: 0;
}

.footerbtn {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
  align-items: center;
  border: 1px solid rgba(229, 229, 229, 1);
}

.footerbtn .line {
  width: 1px;
  height: 28px;
  opacity: 0.4;
  border-right: 1px solid rgba(166, 166, 166, 1);
}
</style>
